import { createFactory, createInputs, createModel } from './onnxInferenceServiceBasicMethods';
var OnnxInferenceService = /** @class */ (function () {
    function OnnxInferenceService() {
    }
    OnnxInferenceService.createFactory = function (appName, version) {
        var _this = this;
        return function () {
            if (!OnnxInferenceService.onnxRetrievalPromise) {
                var createOnnxReference = function () {
                    if (!appName || !version) {
                        return Promise.reject(new Error("Error: appName and/or version not provided"));
                    }
                    return new Promise(function (resolve, reject) {
                        var script = document.createElement('script');
                        script.src = _this.createCdnUrl(appName, version);
                        script.onload = function () {
                            var _a;
                            if (((_a = window === null || window === void 0 ? void 0 : window.top) === null || _a === void 0 ? void 0 : _a.ort) && window.top.ort.InferenceSession && window.top.ort.Tensor) {
                                OnnxInferenceService.onnxRetrievalPromise = Promise.resolve(new OnnxInferenceService());
                                resolve('Success creating inference service');
                            }
                            else {
                                script.remove();
                                reject(new Error('ort.Tensor and/or ort.InferenceSession are undefined'));
                            }
                        };
                        script.onerror = reject;
                        document.body.appendChild(script);
                    });
                };
                return createFactory(createOnnxReference).catch(function (err) {
                    OnnxInferenceService.onnxRetrievalPromise = Promise.reject(err);
                }).then(function () {
                    return OnnxInferenceService.onnxRetrievalPromise;
                });
            }
            else {
                return OnnxInferenceService.onnxRetrievalPromise;
            }
        };
    };
    OnnxInferenceService.createCdnUrl = function (appName, version) {
        // TODO add correct logic
        var cdnUrl = "https://" + appName + version;
        return cdnUrl;
    };
    OnnxInferenceService.prototype.createModel = function (modelUrl, modelName) {
        var _a;
        return createModel(modelUrl, modelName ? modelName : '', (_a = window === null || window === void 0 ? void 0 : window.top) === null || _a === void 0 ? void 0 : _a.ort);
    };
    OnnxInferenceService.prototype.createInputs = function () {
        return createInputs();
    };
    return OnnxInferenceService;
}());
export { OnnxInferenceService };
//# sourceMappingURL=onnxInferenceService.js.map